import { render, staticRenderFns } from "./LatestWorkPage.vue?vue&type=template&id=6f476cd0&scoped=true&"
import script from "./LatestWorkPage.vue?vue&type=script&lang=js&"
export * from "./LatestWorkPage.vue?vue&type=script&lang=js&"
import style0 from "./LatestWorkPage.vue?vue&type=style&index=0&id=6f476cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f476cd0",
  null
  
)

export default component.exports